/* Lemon Park — Furniture landing page behaviour.
   One deferred asset for every lpf-* section, kept separate from
   lp-sections.js so the two landing pages cannot affect each other.

   The hero's own visuals are pure CSS (:checked rules in section-lpf.css), so
   the fabric picker works with this script absent, blocked or still loading.
   Everything here is enhancement: broadcasting the chosen fabric to the
   closing CTA, single-open behaviour on the FAQ, and keeping the selected
   piece visible in the collection's "Shop by piece" row. */
(function () {
  'use strict';

  /* The tag may appear once per section; an identical src is fetched once but
     executed per tag. Run the setup only once. */
  if (window.__lpfSectionsLoaded) return;
  window.__lpfSectionsLoaded = true;

  var EVENT = 'lpf:fabric';

  /* ------------------------------------------------------------ fabric bus */

  var bus = (window.LPFFabric = window.LPFFabric || {
    current: null,
    publish: function (fabric) {
      this.current = fabric;
      document.dispatchEvent(new CustomEvent(EVENT, { detail: fabric }));
    },
    subscribe: function (fn) {
      document.addEventListener(EVENT, function (event) {
        fn(event.detail);
      });
      /* The hero sits above its listeners, so replay the current choice to
         anything that initialises after it. */
      if (this.current) fn(this.current);
    }
  });

  function claim(root, key) {
    if (root.dataset[key] === 'ready') return false;
    root.dataset[key] = 'ready';
    return true;
  }

  /* ------------------------------------------------------------------- hero */

  function initHero(root) {
    if (!claim(root, 'lpfHeroReady')) return;

    var radios = Array.prototype.slice.call(root.querySelectorAll('[data-lpf-fabric]'));
    if (!radios.length) return;

    function publish(radio) {
      bus.publish({
        img: radio.dataset.img || '',
        name: radio.dataset.name || '',
        piece: radio.dataset.piece || ''
      });
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) publish(radio);
      });
    });

    var checked = radios.filter(function (r) { return r.checked; })[0];
    publish(checked || radios[0]);
  }

  /* -------------------------------------------------------------- final CTA */

  function initCta(root) {
    if (!claim(root, 'lpfCtaReady')) return;

    var bg = root.querySelector('[data-lpf-cta-bg]');
    if (!bg) return;

    bus.subscribe(function (fabric) {
      if (fabric.img) bg.style.backgroundImage = "url('" + fabric.img + "')";
    });
  }

  /* -------------------------------------------------------------------- FAQ */

  function initFaq(root) {
    if (!claim(root, 'lpfFaqReady')) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-lpf-faq-item]'));

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  /* ---------------------------------------------------------- shop by piece */

  /* The row scrolls sideways once the pieces outgrow it. Bring the selected
     piece into view so a filtered page never opens with its own choice hidden
     off-screen. A trackpad or a finger can swipe the row but a mouse wheel
     can't, so an arrow shows on each side that has more pieces. */
  function initFilter(root) {
    if (!claim(root, 'lpfFilterReady')) return;

    var list = root.querySelector('.lpf-filter__list');
    if (!list) return;

    var active = root.querySelector('.lpf-filter__item.is-active');
    if (active && list.scrollWidth > list.clientWidth) {
      var item = active.parentElement;
      list.scrollLeft = item.offsetLeft - (list.clientWidth - item.offsetWidth) / 2;
    }

    var prev = root.querySelector('[data-lpf-filter-prev]');
    var next = root.querySelector('[data-lpf-filter-next]');
    if (!prev || !next) return;

    function hide(button, other) {
      /* Hand keyboard focus across rather than drop it when an arrow runs out. */
      if (document.activeElement === button && !other.hidden) other.focus();
      button.hidden = true;
    }

    /* Compare the end pieces with the row's edges rather than scrollLeft with
       0: the row's padding and scroll snapping leave it a few pixels off. */
    function update() {
      var box = list.getBoundingClientRect();
      var first = list.firstElementChild;
      var last = list.lastElementChild;
      var atStart = !first || first.getBoundingClientRect().left >= box.left - 1;
      var atEnd = !last || last.getBoundingClientRect().right <= box.right + 1;
      /* Show before hiding, so there is an arrow to hand focus to. */
      if (!atStart) prev.hidden = false;
      if (!atEnd) next.hidden = false;
      if (atStart) hide(prev, next);
      if (atEnd) hide(next, prev);
    }

    function step(direction) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      list.scrollBy({ left: direction * list.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () {
      step(-1);
    });
    next.addEventListener('click', function () {
      step(1);
    });
    list.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(list);
    } else {
      window.addEventListener('resize', update);
    }
    update();
  }

  /* ------------------------------------------------------------------ wiring */

  var SECTIONS = [
    ['[data-lpf-hero]', initHero],
    ['[data-lpf-cta]', initCta],
    ['[data-lpf-faq]', initFaq],
    ['[data-lpf-filter]', initFilter]
  ];

  function init(scope) {
    SECTIONS.forEach(function (entry) {
      var selector = entry[0];
      var fn = entry[1];

      if (scope.matches && scope.matches(selector)) fn(scope);
      Array.prototype.forEach.call(scope.querySelectorAll(selector), fn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Theme editor: sections are replaced wholesale on every settings change. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
